import { Language } from "../interfaces/language.interface";
import { LOCALE } from "../interfaces/locale.enum";

export const LANGUAGES: Language[] = [
	{
		id: 1,
		name: "English",
		locale: LOCALE.ENGLISH
	},
	{
		id: 2,
		name: "Українська",
		locale: LOCALE.UKRAINIAN
	}
];
